import React from 'react';
import styled from 'styled-components';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Box } from '@origin-digital/layout';
import { Heading3, Text } from '@origin-digital/style-guide';
import OriginStepIconHorizontal from './OriginStepIconHorizontal';
import OriginStepIconVertical from './OriginStepIconVertical';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const getSteps = () => {
  return [
    'Build your solar system',
    'Quote and house assessment',
    'Book your installation',
    'Enjoy saving with solar'
  ];
};

const HeadingContainer = styled(Box)`
  padding-top: 24px;
  margin-left: 32px;
`;

const WhatsNext = () => {
  const theme = useTheme();
  const steps = getSteps();

  if (useMediaQuery(theme.breakpoints.up('sm'))) {
    return (
      <Box display="block" color="white" marginTop={6}>
        <HeadingContainer>
          <Heading3 text="What's next?" />
        </HeadingContainer>
        <Box data-id="stepper-container-horizontal">
          <Stepper classes={{}} alternativeLabel>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel StepIconComponent={OriginStepIconHorizontal}>
                  <Box marginTop={index > 0 ? 4 : -3}>
                    <Text size="sm" fontWeight={index === 0 ? 'bold' : 'regular'}>
                      {label}
                    </Text>
                  </Box>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>
    );
  }

  return (
    <Box display="block" color="white" marginTop={6}>
      <HeadingContainer>
        <Heading3 text="What's next?" />
      </HeadingContainer>
      <Box data-id="stepper-container-vertical" marginLeft={4}>
        <Stepper classes={{}} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel StepIconComponent={OriginStepIconVertical}>
                <Box marginLeft={index > 0 ? 4 : 1} marginTop={-2}>
                  <Text size="sm" fontWeight={index === 0 ? 'bold' : 'regular'}>
                    {label}
                  </Text>
                </Box>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

export default WhatsNext;
